(function () {
    'use strict';

    angular.module('imApp')
    .filter('filterLType', function () {
        return function (items, lType) {
            var filtered = [];

            if (lType === 'base') {
                angular.forEach(items, function (value) {
                    if (value.isOverlay === false) {
                        filtered.push(value);
                    }
                });
            } else if (lType === 'overlay') {
                angular.forEach(items, function (value) {
                    if (value.isOverlay === true) {
                        filtered.push(value);
                    }
                });
            } else {
                return items;
            }

            return filtered;
        };
    })
    .directive('imMapDirective', ['$q', '$ihttp', '$timeout', '$rootScope', '$compile', function ($q, $ihttp, $timeout, $rootScope, $compile) {
        var directive = {
            restrict: 'E',
            scope: {
                //field: '=',         // Links in the values                                      //REQUIRED
                //listItems: '=',     // Used for linking a list to the directive                 //REQUIRED
                center: '=?',       // Used to push the map to a certain long-lat value
                markers: '=?',      // Used for linking marker locations to and from map
                setup: '=?',        // Used for linking variables from database
                fullscreen: '=?',   // Used to link true or false value back to controller
                height: '@?',       // Used to define a base height of map, accepts numeric value, 'dynamic', 'dynamic-o' or 'dynamic-h'
                heightOffset: '@?', // Used in conjuction with 'height' when set to 'dynamic-o'
                optionfunc: '&?',   // Used as reference to function in Controller, used when adding
                markerfunc: '&?'    // Used as reference to function in Controller, used when selecting
            },
            template:
                '<div class="form-group im-no-mar" style="margin-bottom: 0;">' +
                    '<div class="col-xs-12 sp-0">' +
                        //'<im-button-directive name="hidelayers" optionfunc="hideLayers()" glyphs="fa fa-layer-group" btnsize="col-xs-12 im-no-pad"></im-button-directive>' +
                        //'<im-input-directive label="layers" field="model.encodings.selected" type="select" data="model.encodings.data" dataid="item_id" dataname="item_name"></im-input-directive>' +
                        //'<im-input-directive label="layers" field="model.currentLayer" type="select" data="mapOptions.baseLayerList()" dataid="item_id" dataname="item_name"></im-input-directive>' +
                        //'<im-input-directive label="layers" field="model.currentLayer" type="select" data="model.baseLayerList" dataid="item_id" dataname="item_name"></im-input-directive>' +
                        //'<div id="{{model.mId}}" style="width: 100%;" kendo-map ' +
                        '<div ng-hide="showElem(\'map\') !== true" id="{{model.mId}}" class="kendo-map col-xs-12 sp-0" ng-style="{\'height\':model.mapHeightCurrent}"' +
                            //'k-scope-field="spreadsheet" ' +
                            //'k-options="model.mapOptions">' +
                            'k-options="mapOptions">' +
                        '</div>' +
                        //'<div id="{{model.mId}}" style="height: 300px;"></div>' +
                    '</div>' +
                '</div>',
            link: function ($scope) {
                $scope.model = {
                    mId: uuid(),
                    myId: uuid(),
                    map: null,
                    mapHeightMinimum: 262,
                    mapHeightBase: 600,
                    mapHeightCurrent: 600,
                    mapHeightPrevious: 600,
                    mapIsShown: true,
                    isInitialized: false,
                    selectedMarker: null,
                    showAim: true,
                    showScale: true,
                    currentLayer: null,
                    currentLat: 0,
                    currentLng: 0,
                    myPosLat: 0,
                    myPosLng: 0,
                    myPosAlt: 0,
                    myPosAcc: 40,
                    myPosAAc: 0,
                    width: 0,
                    height: 0,
                    panX: 0,
                    panY: 0,
                    viewBox: '0 0 0 0',
                    fullAttribution: '',
                    baseLayerList: [],
                    imMapBtnList: [],
                    imMapMarkers: [],
                    mapOptions: {},
                    isMobile: null
                };

                window.mobileAndTabletcheck = function () {
                    var check = false;
                    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
                    return check;
                };

                $scope.model.isMobile = window.mobileAndTabletcheck();

                $scope.onChange = function (e) {
                    //console.log("Changed: " + e);
                    //console.dir(e);
                };

                $scope.onClick = function (e) {
                    //console.log(kendo.format(
                    //    "Click at :: {0}", e.location.toString()
                    //));
                    //console.log('clicked: ' + e.location.toString());
                    //console.dir(e.location);

                    if (goToIsOn === true && markerClickIsOn === true) {
                        markerClickIsOn = false;
                    } else if (goToIsOn === true) {
                        goToIsOn = false;
                        $scope.selectedMarker = null;
                    }

                    if (layerIsOn === true) {
                        //console.log('layerIsOn: ' + layerIsOn);
                        //if (keepOn === true) {
                        //    keepOn = false;
                        //} else {
                        //    layerIsOn = false;
                        //    keepOn = false;
                        //}
                        layerIsOn = false;
                    }

                    if (markerIsOn === true) {
                        var shp = 'pinTarget';
                        var lat = e.location.lat;
                        var lng = e.location.lng;
                        var clr = 'blue';
                        $scope.model.map.markers.add({
                            shape: shp,
                            location: [e.location.lat, e.location.lng],
                            colorField: clr
                        });

                        $scope.model.imMapMarkers.push({ id: uuid(), lat: lat, lng: lng, shape: shp, type: '', colorField: clr, parms: '' });
                        //markerIsOn = !markerIsOn;
                    }
                };

                $scope.onBeforeReset = function (e) {
                    //console.log("onBeforeReset");
                    //console.dir(e);

                    if (layerIsOn === true) {
                        layerIsOn = false;
                    }

                    //if ($scope.model.showAim === true) showAim(e.sender);
                    if ($scope.model.showScale === true) showScale(e.sender);
                    //showFilterBtn(e.sender);
                    //showPlaceMarkerBtn(e.sender);

                    if ($scope.model.isInitialized === true) return;
                        
                    $scope.model.isInitialized = true;

                    //if (angular.isUndefined($scope.center) && angular.isDefined($scope.markers) && $scope.markers.length > 0) {
                    //    $scope.mapOptions.center = [$scope.markers[0].locations.lat, $scope.markers[0].locations.lng];
                    //    $scope.model.map.center([$scope.markers[0].locations.lat, $scope.markers[0].locations.lng]);
                    //}

                    $scope.model.map = $('#' + $scope.model.mId).data('kendoMap');
                    showCustomMapButtons(e.sender);
                    $scope.mapOptions.hideAll();
                    $scope.model.currentLayer = 0;
                    $scope.mapOptions.show($scope.model.currentLayer);
                    //if ($scope.model.showScale === true) showScale(e.sender);
                    //showFilterBtn(e.sender);
                };

                $scope.onReset = function (e) {
                    //console.log("onReset");
                    //console.dir(e);

                    var width = document.getElementById($scope.model.mId).offsetWidth;
                    var height = document.getElementById($scope.model.mId).offsetHeight;

                    //console.log('width & height');
                    //console.dir(width);
                    //console.dir(height);

                    //$scope.model.panX = -e.originalEvent.scrollLeft;
                    //$scope.model.panY = -e.originalEvent.scrollTop;

                    if (angular.isDefined(width) && width > 0) {
                        $scope.model.width = width;
                    }

                    if (angular.isDefined(height) && height > 0) {
                        $scope.model.height = height;
                    }

                    $scope.model.viewBox = '0 0 ' + $scope.model.width + ' ' + $scope.model.height;
                };

                $scope.onPan = function (e) {
                    //console.log("onPan: " + e);
                    //console.dir(e);
                    if (layerIsOn === true) {
                        layerIsOn = false;
                    }

                    if (panIsOn === false) {
                        panIsOn = true;
                    }

                    $scope.model.panX = -e.originalEvent.scrollLeft;
                    $scope.model.panY = -e.originalEvent.scrollTop;

                    //$scope.model.panX -= e.center.lng - e.origin.lng;
                    //$scope.model.panY -= e.center.lat - e.origin.lat;

                };

                $scope.onPanEnd = function (e) {
                    //console.log("onPanEnd: " + e);
                    //console.dir(e);

                    $scope.model.panX = -e.originalEvent.scrollLeft;
                    $scope.model.panY = -e.originalEvent.scrollTop;

                    //$scope.model.panX -= e.center.lng - e.origin.lng;
                    //$scope.model.panY -= e.center.lat - e.origin.lat;
                };

                //$scope.onRender = function (e) {
                //    //console.log("Spreadsheet rendered");
                //    //console.dir(e);
                //    if ($scope.model.actionbarVisible === true) {
                //        if (angular.isDefined(e.sender)
                //            && angular.isDefined(e.sender.element)
                //            && angular.isDefined(e.sender.element.children())
                //            && angular.isDefined(e.sender.element.children()[0])) {
                //            e.sender.element.children()[0].remove();
                //            $scope.model.actionbarVisible = false;
                //            //var height = window.innerHeight;
                //            //e.sender.element.innerHeight(height-300);
                //        }
                //    }
                //};
                $scope.onMarkerClick = function (e) {
                    console.log("Marker Clicked :: " + e);
                    console.dir(e);
                    //e.preventDefault();
                    //console.dir(e.marker.options.id);

                    plusIsOn = false;
                    goToIsOn = true;

                    if (angular.isFunction($scope.markerfunc) === true) {
                        var selectedId = e.marker.options.id;
                        //var selectedMarker = null;
                        //$scope.model.selectedMarker = null;

                        for (var i = 0; i < $scope.model.imMapMarkers.length; i++) {
                            if ($scope.model.imMapMarkers[i].id === selectedId) {
                                $scope.model.selectedMarker = $scope.model.imMapMarkers[i];
                                markerClickIsOn = true;
                                break;
                            }
                        }

                        //if (selectedMarker !== null) {
                        //    return $scope.markerfunc({ marker: selectedMarker});
                        //}
                    }
                };
                //$scope.onSelect = function (e) {
                //    //console.log("File selected :: " + e);
                //    //console.dir(e);
                //};
                //$scope.onRemove = function (e) {
                //    //console.log("File removed :: " + e);
                //    //console.dir(e);
                //};
                //$scope.onAdd = function (e) {
                //    console.log("Task added: " + e);
                //};
                //$scope.onEdit = function (e) {
                //    console.log("Task about to be edited :: " + e);
                //};
                //$scope.onCancel = function (e) {
                //    console.log("Cancel task edit :: " + e);
                //};
                //$scope.onSave = function (e) {
                //    console.log("Task saved :: " + e); //Saved
                //    console.dir(e);
                //};
                //$scope.onDataBinding = function (e) {
                //    console.log("Gantt data binding");
                //    //console.dir(e);
                //};
                //$scope.onDataBound = function (e) {
                //    console.log("Map data bound");
                //    //console.dir(e);
                //};
                //$scope.onNavigate = function (e) {
                //    console.log(kendo.format("navigate:: view:{0};", e.view));
                //    console.dir(e);
                //};
                //$scope.onMoveStart = function (e) {
                //    console.log("moveStart");
                //};
                //$scope.onMove = function (e) {
                //    console.log("move");
                //};
                //$scope.onMoveEnd = function (e) {
                //    console.log("moveEnd");
                //    console.dir(e);
                //};
                //$scope.onResizeStart = function (e) {
                //    console.log("resizeStart");
                //};
                $scope.onResize = function (e) {
                    //console.log("resize");
                };
                //$scope.onResizeEnd = function (e) {
                //    console.log("resizeEnd");
                //};
                $scope.onZoomStart = function (e) {
                    //console.log("zoomStart");
                    //console.dir(e.originalEvent);
                    //console.log(angular.toJson(e.originalEvent));
                };
                $scope.onZoomEnd = function (e) {
                    //console.log("zoomEnd");
                    //console.dir(e.originalEvent);
                    //console.log(angular.toJson(e.originalEvent));
                    //console.dir($scope.model);
                };

                //function isInArray(value, array) {
                //    return array.indexOf(value) > -1;
                //}
                //function isNumber(n) {
                //    return !isNaN(parseFloat(n)) && isFinite(n);
                //}

                $scope.reCenter = function () {
                    var lat = $scope.model.map.options.center[0];
                    var lng = $scope.model.map.options.center[1];

                    if ($scope.model.currentLat === lat && $scope.model.currentLng === lng) return;

                    $scope.model.currentLat = lat;
                    $scope.model.currentLng = lng;

                    $scope.model.map.center([lat, lng]);

                    //console.log('recentering');
                };

                $scope.layerAttribution = function (attr) {
                    if (attr === '' || $scope.model.fullAttribution.includes(attr)) {
                        return '';
                    } else {
                        $scope.model.fullAttribution += attr;
                        return attr;
                    }
                };

                //$scope.hideLayers = function () {
                //    if ($scope.model.currentLayer === null) {
                //        $scope.model.currentLayer = $scope.mapOptions.layers.length - 1;
                //        console.log('layers: ' + $scope.mapOptions.layers.length);
                //        //$scope.mapOptions.hide();
                //        $scope.mapOptions.hideAll();
                //        $scope.hideLayers();
                //        //} else if ($scope.model.currentLayer === 0) {
                //        //    $scope.mapOptions.hide();
                //        //    $scope.model.currentLayer = 1;
                //        //    $scope.mapOptions.show();
                //        //} else if ($scope.model.currentLayer === 1) {
                //        //    $scope.mapOptions.hide();
                //        //    $scope.model.currentLayer = 0;
                //        //    $scope.mapOptions.show();
                //    } else if ($scope.mapOptions.layers.length > 0) {
                //        if ($scope.mapOptions.layers.length === 1) {
                //            if ($scope.model.currentLayer >= $scope.mapOptions.layers.length) {
                //                $scope.model.currentLayer = 0;
                //                $scope.mapOptions.hide();
                //            } else {
                //                $scope.mapOptions.show();
                //                $scope.model.currentLayer++;
                //            }
                //        } else {
                //            $scope.mapOptions.hide();
                //            var firstCurrent = $scope.model.currentLayer;
                //            $scope.model.currentLayer++;
                //            //while ($scope.model.currentLayer !== firstCurrent && $scope.mapOptions.layers[$scope.model.currentLayer].isOverlay === true) {
                //            //    if ($scope.model.currentLayer >= $scope.mapOptions.layers.length) {
                //            //        $scope.model.currentLayer = 0;
                //            //    } else {
                //            //        $scope.model.currentLayer++;
                //            //    }
                //            //}
                //            if ($scope.model.currentLayer >= $scope.mapOptions.layers.length) {
                //                $scope.model.currentLayer = 0;
                //            }
                //            while (($scope.mapOptions.layers[$scope.model.currentLayer].isOverlay === true || $scope.mapOptions.layers[$scope.model.currentLayer].isDisabled === true) && $scope.model.currentLayer !== firstCurrent) {
                //                $scope.model.currentLayer++;
                //                if ($scope.model.currentLayer >= $scope.mapOptions.layers.length) {
                //                    $scope.model.currentLayer = 0;
                //                }
                //            }
                //            //if ($scope.model.currentLayer === 2) {
                //            //    $scope.mapOptions.show(0);
                //            //}
                //            $scope.mapOptions.show();
                //        }
                //    }

                //    //if ($scope.model.currentLayer === null) {
                //    //    $scope.model.currentLayer = 1;
                //    //    $scope.hideLayers();
                //    //} else if ($scope.model.currentLayer === 0) {
                //    //    $scope.mapOptions.layers[0].show();
                //    //    $scope.mapOptions.layers[1].hide();
                //    //    $("#map").data("kendoMap").
                //    //    $scope.model.currentLayer = 1;
                //    //} else if ($scope.model.currentLayer === 1) {
                //    //    $scope.mapOptions.layers[1].show();
                //    //    $scope.mapOptions.layers[0].hide();
                //    //    $scope.model.currentLayer = 0;
                //    //}
                //};

                $scope.centerMap = function (latitude, longitude) {
                    var lat = latitude || $scope.model.myPosLat;
                    var lng = longitude || $scope.model.myPosLng;
                    //var lat = $scope.model.myPosLat;
                    //var lng = $scope.model.myPosLng;

                    $scope.model.map.center([lat, lng]);
                };

                $scope.getMyPosition = function () {
                    navigator.geolocation.getCurrentPosition(function (data) {
                        //console.log('data');
                        console.dir(data);
                        $scope.model.myPosLat = data.coords.latitude;
                        $scope.model.myPosLng = data.coords.longitude;
                        $scope.model.myPosAlt = data.coords.altitude;
                        $scope.model.myPosAcc = data.coords.accuracy;
                        $scope.model.myPosAAc = data.coords.altitudeAccuracy;

                        var id = $scope.model.myId;
                        var lat = $scope.model.myPosLat;
                        var lng = $scope.model.myPosLng;
                        var containsMe = false;
                        var containsMeIndex;

                        for (var i = 0; i < $scope.model.imMapMarkers.length; i++) {
                            if ($scope.model.imMapMarkers[i].id === id) {
                                containsMe = true;
                                containsMeIndex = i;
                                break;
                            }
                        }

                        if (!containsMe) {
                            var shp = 'pinTarget';
                            var clr = 'red';
                            $scope.model.map.markers.add({
                                id: id,
                                shape: shp,
                                location: [lat, lng],
                                colorField: clr
                            });

                            $scope.model.imMapMarkers.push({ id: id, lat: lat, lng: lng, shape: shp, type: '', colorField: clr, parms: '' });
                        } else {
                            var marker = $scope.model.map.markers.items[containsMeIndex];

                            //console.dir($scope.model.map.markers);

                            var loc = marker.location();
                            marker.location([lat, lng]);
                            //$scope.model.map.markers.add({
                            //    id: id,
                            //    shape: shp,
                            //    location: [lat, lng],
                            //    colorField: clr
                            //});

                            //$scope.model.imMapMarkers.push({ id: id, lat: lat, lng: lng, shape: shp, type: '', colorField: clr });
                            $scope.model.imMapMarkers[containsMeIndex].lat = lat;
                            $scope.model.imMapMarkers[containsMeIndex].lng = lng;
                        }

                        if (!layerIsOn && !panIsOn)
                            $scope.centerMap(lat, lng);
                    });
                };

                $scope.toggleLayer = function (layer) {
                    if (layer.isShown) {
                        $scope.mapOptions.hide(layer.layerId);
                    } else {
                        $scope.mapOptions.show(layer.layerId);
                    }
                };

                $scope.toggleLayerAll = function () {
                    for (var l = 0; l < $scope.mapOptions.baseLayerList().length; l++) {
                        $scope.toggleLayer($scope.mapOptions.baseLayerList()[l]);
                    }
                };

                $scope.toggleOverlay = function (overlay) {
                    if (overlay.isShown) {
                        $scope.mapOptions.hideOverlay(overlay.layerId);
                    } else {
                        $scope.mapOptions.showOverlay(overlay.layerId);
                    }
                };

                $scope.toggleOverlayAll = function () {
                    for (var l = 0; l < $scope.mapOptions.overlayList().length; l++) {
                        $scope.toggleOverlay($scope.mapOptions.overlayList()[l]);
                    }
                };

                var timer = null;
                //var keepOn = false;
                var layerIsOn = false;
                var markerIsOn = false;
                var aimIsOn = false;
                var myCircleIsOn = false;
                var myPosIsOn = false;
                var autoTrackIsOn = false;
                var plusIsOn = false;
                var goToIsOn = false;
                var markerClickIsOn = false;
                var fullIsOn = false;
                var panIsOn = false;
                //var aimIsOn = false;

                $scope.toggleFullscreen = function () {
                    //var elem = document.getElementById("myvideo");
                    //console.log('fullscrnbtn clicked');
                    //console.log('isMobile? ' + $scope.model.isMobile);
                    //if (elem.requestFullscreen) {
                    //    elem.requestFullscreen();
                    //} else if (elem.mozRequestFullScreen) { /* Firefox */
                    //    elem.mozRequestFullScreen();
                    //} else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                    //    elem.webkitRequestFullscreen();
                    //} else if (elem.msRequestFullscreen) { /* IE/Edge */
                    //    elem.msRequestFullscreen();
                    //}
                    //console.dir($('#' + $scope.model.mId));
                    if ($scope.model.isMobile === false) {
                        var elem = $('#' + $scope.model.mId)[0];
                        if (!fullIsOn) {
                            if (elem.requestFullscreen) {
                                elem.requestFullscreen();
                            } else if (elem.mozRequestFullScreen) { /* Firefox */
                                elem.mozRequestFullScreen();
                            } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                                elem.webkitRequestFullscreen();
                            } else if (elem.msRequestFullscreen) { /* IE/Edge */
                                elem.msRequestFullscreen();
                            }
                        } else {
                            //console.dir(document);
                            if (document.exitFullscreen) {
                                document.exitFullscreen();
                            } else if (document.mozCancelFullScreen) { /* Firefox */
                                document.mozCancelFullScreen();
                            } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                                document.webkitExitFullscreen();
                            } else if (document.msExitFullscreen) { /* IE/Edge */
                                document.msExitFullscreen();
                            }
                        }
                    } else if ($scope.model.isMobile === true) {
                        fullIsOn = !fullIsOn;
                        $scope.fullscreen = fullIsOn;
                        //$('#' + $scope.model.mId)[0].height = '100vh';
                        var h = $(window).innerHeight() - 70;
                        $scope.model.mapHeightPrevious = $scope.model.mapHeightCurrent;

                        if (fullIsOn) {
                            $scope.model.mapHeightCurrent = h;
                        } else {
                            $scope.model.mapHeightCurrent = $scope.model.mapHeightBase;
                        }
                    }

                    //if ($scope.model.isMobile === false) {
                    //    fullIsOn = !fullIsOn;
                    //    $scope.fullscreen = fullIsOn;
                    //    //var elem = $('#' + $scope.model.mId)[0];
                    //    var h = $(window).innerHeight() - 70;

                    //    $scope.model.mapHeightPrevious = $scope.model.mapHeightCurrent;

                    //    if (fullIsOn) {
                    //        $scope.model.mapHeightCurrent = h;
                    //    } else {
                    //        $scope.model.mapHeightCurrent = $scope.model.mapHeightBase;
                    //    }

                    //    //console.dir(document);
                    //    //console.dir($(window));
                    //    //console.dir(elem);


                    //    //$('#' + $scope.model.mId)[0].height = '100vh';
                    //}

                    //console.dir($scope.model.map);
                    ////$scope.model.map._events.reset();
                    ////$scope.model.map.options.reset();
                    ////$scope.model.map.options.resize(true);
                    ////$scope.model.map.center($scope.center);

                    ////var m = $("#" + $scope.model.mId).data("kendoMap").resize(true);
                    //var m = $("#" + $scope.model.mId).data("kendoMap");
                    //$("#" + $scope.model.mId).data("kendoMap").resize(true);

                    //console.dir(m);

                    if (angular.isDefined(timer)) {
                        $timeout.cancel(timer);
                    }

                    timer = $timeout(function () {
                        $scope.model.map.center($scope.center);
                    }, 100);


                    //fullIsOn = !fullIsOn;
                };

                $scope.toggleLayer = function (overlay) {
                    //layerIsOn = !layerIsOn;
                    //if (layerIsOn === true) {
                    //    keepOn = true;
                    //}
                    layerIsOn = true;
                };

                $scope.toggleLayerSelection = function (layer) {
                    //console.log('layerselection clicked: ' + $scope.model.currentLayer);
                    //console.dir(layer);
                    //if (layer.layerId === $scope.model.currentLayer) return;
                    $scope.mapOptions.hideBaseAll();
                    $scope.mapOptions.show(layer.layerId);
                };

                $scope.toggleOverlaySelection = function (layer) {
                    //console.log('layerselection clicked: ' + $scope.model.currentLayer);
                    //console.dir(layer);
                    //if (layer.layerId === $scope.model.currentLayer) return;
                    //$scope.mapOptions.hideAll();
                    //if()
                    //$scope.mapOptions.show(layer.layerId);
                    $scope.mapOptions.toggle(layer.layerId);
                };

                $scope.toggleMyPos = function () {
                    //console.log('myposbtn clicked');
                    if (!myPosIsOn) myPosIsOn = !myPosIsOn;

                    //if (autoTrackIsOn) {
                        panIsOn = false;
                    //}
                    $scope.getMyPosition();
                };

                var trackerTimer = null;

                var autoTrack = function () {
                    if (angular.isDefined(trackerTimer)) {
                        //console.log('get cancelled');
                        $timeout.cancel(trackerTimer);
                    }

                    if (autoTrackIsOn === false) return;

                    $scope.getMyPosition();

                    trackerTimer = $timeout(function () {
                        //console.log('Tracking');
                        autoTrack();
                    }, 2000);
                };

                $scope.toggleMyPosTrack = function () {
                    //console.log('mypostrackbtn clicked');
                    autoTrackIsOn = !autoTrackIsOn;

                    if (autoTrackIsOn === true) {
                        //console.log('Tracking start');
                        autoTrack();
                    } else {
                        if (angular.isDefined(trackerTimer)) {
                            //console.log('get cancelled');
                            $timeout.cancel(trackerTimer);
                        }
                    }
                };

                $scope.toggleCenter = function () {
                    //console.log('centerbtn clicked');
                    $scope.model.map.center($scope.center);
                };

                $scope.toggleAim = function () {
                    //console.log('aimbtn clicked');
                    aimIsOn = !aimIsOn;

                    if (markerIsOn === true) {
                        markerIsOn = !markerIsOn;
                    }
                };

                $scope.togglePlaceMarker = function () {
                    //console.log('markerbtn clicked');
                    //for (var i = 0; i < $scope.imMapBtnList.length; i++) {
                    //    if ()
                    //}
                    //console.dir(this);

                    if (aimIsOn === false) {
                        markerIsOn = !markerIsOn;
                    } else if (aimIsOn === true) {
                        //console.log('markerbtn2 clicked: ');
                        //console.dir($scope.model.map.options.center);
                        var shp = 'pinTarget';
                        var lat = $scope.model.map.options.center[0];
                        var lng = $scope.model.map.options.center[1];
                        var clr = 'green';
                        $scope.model.map.markers.add({
                            shape: shp,
                            location: [lat, lng],
                            colorField: clr
                        });

                        $scope.model.imMapMarkers.push({ id: uuid(), lat: lat, lng: lng, shape: shp, type: '', colorField: clr, parms: '' });
                    }

                    //markerIsOn = !markerIsOn;
                    //console.log('markerbtn clicked: ' + markerIsOn);
                };

                $scope.togglePlus = function () {
                    //console.log('plusbtn clicked');
                    plusIsOn = !plusIsOn;
                    goToIsOn = false;

                    //if (markerIsOn === true) {
                    //    markerIsOn = !markerIsOn;
                    //}
                };

                $scope.toggleConfirm = function () {
                    //console.log('confirmbtn clicked');
                    //aimIsOn = !aimIsOn;
                    plusIsOn = false;

                    var shp = 'pinTarget';
                    var lat = $scope.model.map.options.center[0];
                    var lng = $scope.model.map.options.center[1];
                    var clr = 'green';
                    $scope.model.map.markers.add({
                        shape: shp,
                        location: [lat, lng],
                        colorField: clr
                    });

                    $scope.model.imMapMarkers.push({ id: uuid(), lat: lat, lng: lng, shape: shp, type: '', colorField: clr, parms: '' });

                    if (angular.isFunction($scope.optionfunc) === true) {
                        return $scope.optionfunc({ location: { lat: lat, lng: lng } });
                    }

                    //if (markerIsOn === true) {
                    //    markerIsOn = !markerIsOn;
                    //}
                };

                $scope.toggleGoTo = function () {
                    //console.log('gotobtn clicked');
                    goToIsOn = false;

                    if ($scope.model.selectedMarker !== null) {
                        return $scope.markerfunc({ marker: $scope.model.selectedMarker });
                    }
                };

                //$scope.togglePlaceMarker2 = function () {
                //    console.log('markerbtn2 clicked: ');
                //    console.dir($scope.model.map.options.center);
                //    var shp = 'pinTarget';
                //    var lat = $scope.model.map.options.center[0];
                //    var lng = $scope.model.map.options.center[1];
                //    var clr = 'green';
                //    $scope.model.map.markers.add({
                //        shape: "pinTarget",
                //        location: [lat, lng],
                //        colorField: clr
                //    });

                //    $scope.model.imMapMarkers.push({ id: uuid(), lat: lat, lng: lng, shape: shp, type: '', colorField: clr });
                //};

                $scope.toggleMore = function () {
                    //console.log('morebtn clicked');
                    myCircleIsOn = !myCircleIsOn;

                    //$scope.model.myPosAcc += 10;
                };

                $scope.kBtnClass = function (condition) {
                    var allClass = 'k-button im-k-custom-map-btn';

                    if (condition === 'layer') {
                        //allClass += ' btn-k';
                        if (layerIsOn === true) allClass += ' im-k-control-layers-expanded';
                    }

                    if (condition === 'layerExpanded') {
                        //allClass = 'im-k-control-layers im-k-control im-k-control-layers-expanded';
                        allClass = 'im-k-control-layers-expanded';
                        //if (layerIsOn === true) allClass += ' im-k-control-layers-expanded';
                    }

                    //if (condition === 'mypostrack') {
                    //    allClass += ' btn-k';
                    //    if (autoTrackIsOn === true) allClass += '-recording';
                    //}

                    if (condition === 'placemarker') {
                        allClass += ' btn-k';
                        if (markerIsOn === true) allClass += '-pressed';
                    }

                    if (condition === 'aim') {
                        allClass += ' btn-k';
                        if (aimIsOn === true) allClass += '-pressed';
                    }

                    if (condition === 'plus') {
                        allClass += ' btn-k';
                    }

                    if (condition === 'confirm') {
                        allClass += ' btn-k';
                        if (plusIsOn === true) allClass += '-success';
                    }

                    if (condition === 'goto') {
                        allClass += ' btn-k';
                        if (goToIsOn === true) allClass += '-pressed';
                    }

                    return allClass;
                };

                $scope.kBtnIconClass = function (condition) {
                    var allClass = 'im-k-custom-map-btn-icon ';
                    switch (true) {
                        case condition === 'fullscreen':
                            //allClass += 'fa fa-expand';
                            allClass += 'k-icon k-i-full-screen';
                            if (fullIsOn === true) allClass += '-exit';
                            break;
                        case condition === 'layer':
                            allClass += 'k-icon k-i-globe-outline';
                            //allClass += 'fab fa-buffer';
                            break;
                        case condition === 'mypos':
                            allClass += 'fa fa-street-view';
                            //if (markerIsOn===true) allClass += ' im-k-pressed';
                            break;
                        case condition === 'mypostrack':
                            //allClass += 'fa fa-compass';
                            allClass += 'fa fa-circle';
                            //allClass += 'glyphicon glyphicon-record';
                            //if (markerIsOn===true) allClass += ' im-k-pressed';
                            if (autoTrackIsOn === true) allClass += ' im-k-icon-red';
                            break;
                        case condition === 'center':
                            //allClass += 'fa fa-street-view';<i class="fa fa-compass"></i>
                            allClass += 'fa fa-location-arrow';
                            //if (markerIsOn===true) allClass += ' im-k-pressed';
                            break;
                        case condition === 'aim':
                            allClass += 'fa fa-bullseye';
                            //if (markerIsOn===true) allClass += ' im-k-pressed';
                            break;
                        case condition === 'placemarker':
                            allClass += 'k-icon k-i-marker-pin';
                            //if (markerIsOn===true) allClass += ' im-k-pressed';
                            if (aimIsOn === true) allClass += '-target';
                            break;
                        case condition === 'plus':
                            //allClass += 'glyphicon glyphicon-plus';
                            allClass += 'fa fa-plus';
                            //if (markerIsOn===true) allClass += ' im-k-pressed';
                            break;
                        case condition === 'confirm':
                            //allClass += 'glyphicon glyphicon-ok';
                            allClass += 'fa fa-check im-k-icon-white';
                            //if (markerIsOn===true) allClass += ' im-k-pressed';
                            break;
                        case condition === 'goto':
                            //allClass += 'glyphicon glyphicon-ok';
                            allClass += 'fa fa-chevron-right im-k-icon-white';
                            //if (markerIsOn===true) allClass += ' im-k-pressed';
                            break;
                        case condition === 'more':
                            allClass += 'k-icon k-i-more-vertical';
                            break;
                        default:
                            allClass += '';
                    }
                    return allClass;
                };

                $scope.showElem = function (condition) {
                    if (condition === 'map' && $scope.mapIsShown === false
                        || condition === 'layer' && layerIsOn === true
                        || condition === 'layerExpanded' && layerIsOn === false
                        || condition === 'target' && aimIsOn === false && condition === 'target' && plusIsOn === false
                        || condition === 'circle' && myCircleIsOn === false
                        || condition === 'plus' && plusIsOn === false
                        || condition === 'goto' && goToIsOn === false)
                        return false;
                    else
                        return true;
                };

                function showCustomMapButtons(map) {
                    // Add a top-level div
                    var wrap = $(".im-k-custom-wrap", map.element);
                    if (wrap.length === 0) {
                        wrap = $("<div class='im-k-custom-wrap' />").appendTo($('#' + $scope.model.mId));
                    }

                    //console.log('center');
                    //console.dir($scope.center);

                    // Render template
                    var template = kendo.template(
                        //'<div class="fa fa-bullseye" style="color: black; font-size: 32px;"></div>' +
                        //'<div class="k-map-controls fa fa-bullseye" style="color: black; font-size: 28px; pointer-events: none; top: 50%; right: 50%;"></div>' +
                        //'<div class="k-map-controls im-k-control-target" style="color: black; font-size: 28px; pointer-events: none; top: 50%; right: 50%;">' +
                        '<div ng-hide="showElem(\'target\') !== true" class="k-map-controls im-k-control-target">' +
                            //'<img src="https://img.icons8.com/ios/25/000000/define-location.png">'+
                            //'<img src="https://img.icons8.com/dotty/80/000000/accuracy.png">'+
                            '<img class="im-k-target"" src="images/mapTarget.png">'+
                        '</div > ' +
                        //'<div ng-hide="showElem(\'circle\') !== true" class="k-map-controls im-k-control-circle" style="height: 100%; width: 100%;">' +
                        //    '<svg height="100%" width="100%" style="display: block;" viewBox="0 0 1185 878" transform="translate(-40,-40)">' +
                        //'<div ng-hide="showElem(\'circle\') !== true" class="k-map-controls im-k-control-circle">' +
                        //    '<svg ng-attr-transform="translate({{-model.myPosAcc-1}},{{-model.myPosAcc-1}})">' +
                        //        '<g style="visibility: visible; overflow: hidden;" ng-attr-transform="translate({{model.myPosAcc+1}},{{model.myPosAcc+1}})">' +
                        //            '<circle ng-attr-cx="{{$scope.center[0]}}" ng-attr-cy="{{$scope.center[1]}}" ng-attr-r="{{model.myPosAcc}}" stroke="blue" stroke-width="2" stroke-opacity="0.6" stroke-linecap="round" stroke-linejoin="round" fill="blue" fill-opacity="0.2"/>' +
                        //        '</g>' +
                        //    '</svg>' +
                        //'</div >' +
                        '<div ng-hide="showElem(\'circle\') !== true" class="k-map-controls im-k-control-circle">' +
                            '<svg ng-attr-width="{{model.width}}" ng-attr-height="{{model.height}}" ng-attr-viewBox="{{model.viewBox}}">' +
                                '<g style="visibility: visible; overflow: hidden;" ng-attr-transform="translate({{(model.width/2)+model.panX}},{{(model.height/2)+model.panY}})">' +
                                    '<circle ng-attr-cx="{{$scope.center[0]}}" ng-attr-cy="{{$scope.center[1]}}" ng-attr-r="{{model.myPosAcc}}" stroke="blue" stroke-width="2" stroke-opacity="0.6" stroke-linecap="round" stroke-linejoin="round" fill="blue" fill-opacity="0.2"/>' +
                                '</g>' +
                            '</svg>' +
                        '</div >' +
                        '<div class="k-map-controls k-pos-top k-pos-right">' +
                            '<div class="im-btn-group-v">' +
                                '<button ng-hide="showElem(\'layer\') !== true" ng-class="kBtnClass(\'fullscreen\')" ng-click="toggleFullscreen()" title="fullscreen" aria-label="fullscreen">' +
                                    '<span ng-class="kBtnIconClass(\'fullscreen\')"></span>' +
                                '</button>' +
                                '<button ng-hide="showElem(\'layer\') !== true" ng-class="kBtnClass(\'layer\')" ng-click="toggleLayer()" title="layer" aria-label="layer">' +
                                    '<span ng-class="kBtnIconClass(\'layer\')"></span>' +
                                '</button>' +
                                '<div ng-hide="showElem(\'layerExpanded\') !== true" ng-class="kBtnClass(\'layerExpanded\')" ng-click="toggleLayer()">' +
                                    '<div class="im-k-control-layers-list" ng-repeat="layer in mapOptions.layers|filterLType:\'base\'">' +
                                        '<div>'+
                                            '<input type="radio" class="im-k-control-layers-selector" name="im-k-base-layers" ng-model="$parent.model.currentLayer" ng-value="layer.layerId" ng-change="toggleLayerSelection(layer)">'+
                                                ' {{layer.layerName}}'+
                                        '</div>'+
                                    '</div>' +
                                    '<div ng-if="mapOptions.overlayList().length > 0">' +
                                        '<div class="im-k-control-layers-separator"></div>' +
                                        '<div class="im-k-control-layers-list" ng-repeat="layer in mapOptions.layers|filterLType:\'overlay\'">' +
                                            '<div>'+
                                                '<input class="im-checkbox input-text" type="checkbox" ng-model="layer.isShown" ng-change="toggleOverlaySelection(layer)"/>' +
                                                    ' {{layer.layerName}}'+
                                            '</div>'+
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                                '<button ng-hide="showElem(\'layer\') !== true" ng-class="kBtnClass(\'mypos\')" ng-click="toggleMyPos()" title="mypos" aria-label="mypos">' +
                                    '<span ng-class="kBtnIconClass(\'mypos\')"></span>' +
                                '</button>' +
                                '<button ng-hide="showElem(\'layer\') !== true" ng-class="kBtnClass(\'mypostrack\')" ng-click="toggleMyPosTrack()" title="mypostrack" aria-label="mypostrack">' +
                                    '<span ng-class="kBtnIconClass(\'mypostrack\')"></span>' +
                                '</button>' +
                                //'<button ng-hide="showElem(\'layer\') !== true" ng-class="kBtnClass(\'center\')" ng-click="toggleCenter()" title="center" aria-label="center">' +
                                //    '<span ng-class="kBtnIconClass(\'center\')"></span>' +
                                //'</button>' +
                                //'<button ng-hide="showElem(\'layer\') !== true" ng-class="kBtnClass(\'aim\')" ng-click="toggleAim()" title="aim" aria-label="aim">' +
                                //    '<span ng-class="kBtnIconClass(\'aim\')"></span>' +
                                //'</button>' +
                                //'<button ng-hide="showElem(\'layer\') !== true" ng-class="kBtnClass(\'placemarker\')" ng-click="togglePlaceMarker()" title="placemarker" aria-label="placemarker">' +
                                //    '<span ng-class="kBtnIconClass(\'placemarker\')"></span>' +
                                //'</button>' +
                                '<button ng-hide="showElem(\'layer\') !== true" ng-class="kBtnClass(\'plus\')" ng-click="togglePlus()" title="plus" aria-label="plus">' +
                                    '<span ng-class="kBtnIconClass(\'plus\')"></span>' +
                                '</button>' +
                                '<button ng-hide="showElem(\'layer\') !== true || showElem(\'plus\') !== true" ng-class="kBtnClass(\'confirm\')" ng-click="toggleConfirm()" title="confirm" aria-label="confirm">' +
                                    '<span ng-class="kBtnIconClass(\'confirm\')"></span>' +
                                '</button>' +
                                '<button ng-hide="showElem(\'layer\') !== true || showElem(\'goto\') !== true" ng-class="kBtnClass(\'goto\')" ng-click="toggleGoTo()" title="goto" aria-label="goto">' +
                                    '<span ng-class="kBtnIconClass(\'goto\')"></span>' +
                                '</button>' +
                            '</div>' +
                        '</div>' +
                        '<div class="k-map-controls k-pos-bottom k-pos-left">' +
                            '<div class="im-btn-group-v">' +
                                '<button ng-class="kBtnClass(\'more\')" ng-click="toggleMore()" title="more" aria-label="more">' +
                                    '<span ng-class="kBtnIconClass(\'more\')"></span>' +
                                '</button>' +
                            '</div>' +
                        '</div>'
                    );
                    //var data = {
                    //    btn: function test() { console.log('Test is working'); }
                    //    //btn: $scope.hideLayers()
                    //    //size: SIZE,
                    //    //scale: scale
                    //};

                    try {
                        $compile(wrap.html(template))($scope);
                    } catch (err) {
                        console.log('compile error: ' + err);
                    }
                }

                //function showFilterBtn(map) {
                //    // Add a top-level div for the scale indicator
                //    var wrap = $(".im-kendo-filter-wrap", map.element);
                //    if (wrap.length === 0) {
                //        wrap = $("<div class='im-kendo-filter-wrap' />").appendTo($('#' + $scope.model.mId));
                //    }

                //    // Render template
                //    var template = kendo.template(
                //        '<div class="k-map-controls k-pos-top k-pos-right">' +
                //            '<button class="k-button im-kendo-filter" ng-click="toggleOverlayAll()" title="layer" aria-label="layer">' +
                //                '<span class="k-icon k-i-globe-outline"></span>' +
                //            '</button>' +
                //        '</div>'
                //    );
                //    var data = {
                //        btn: function test() { console.log('Test is working'); }
                //        //btn: $scope.hideLayers()
                //        //size: SIZE,
                //        //scale: scale
                //    };

                //    try {
                //        $compile(wrap.html(template))($scope);
                //    } catch (err) {
                //        console.log('compile error: ' + err);
                //    }
                //}

                //function showPlaceMarkerBtn(map) {
                //    // Add a top-level div for the scale indicator
                //    var wrap = $(".im-kendo-place-marker-wrap", map.element);
                //    if (wrap.length === 0) {
                //        wrap = $("<div class='im-kendo-place-marker-wrap' />").appendTo($('#' + $scope.model.mId));
                //    }

                //    // Render template
                //    var template = kendo.template(
                //        '<div class="k-map-controls k-pos-top k-pos-right">' +
                //            '<button class="k-button im-kendo-place-marker" ng-click="togglePlaceMarker()" title="placemarker" aria-label="placemarker">' +
                //                '<span class="k-icon k-i-marker-pin"></span>' +
                //            '</button>' +
                //        '</div>'
                //    );
                //    var data = {
                //        btn: function test() { console.log('Test is working'); }
                //        //btn: $scope.hideLayers()
                //        //size: SIZE,
                //        //scale: scale
                //    };

                //    try {
                //        $compile(wrap.html(template))($scope);
                //    } catch (err) {
                //        console.log('compile error: ' + err);
                //    }
                //}

                //function showAim(map) {
                //    //var Location = kendo.dataviz.map.Location;

                //    //// Indicator size in px
                //    //var SIZE = 100;

                //    //var extent = map.extent();
                //    //var center = map.center();

                //    //// Calculate scale in meters / pixel
                //    //var width = map.element.width();
                //    //var scale = Math.round(distance / width);

                //    // Add a top-level div
                //    var wrap = $(".im-kendo-aim-wrap", map.element);
                //    if (wrap.length === 0) {
                //        wrap = $("<div class='im-kendo-aim-wrap' />").appendTo($('#' + $scope.model.mId));
                //    }

                //    // Render template
                //    var template = kendo.template(
                //        //'<div class="im-k-aim">' +
                //            '<div class="fa fa-bullseye" style="color: black; font-size: 32px;"></div>'
                //        //'</div>'
                //    );

                //    try {
                //        $compile(wrap.html(template))($scope);
                //    } catch (err) {
                //        console.log('compile error: ' + err);
                //    }
                //}

                function showScale(map) {
                    var Location = kendo.dataviz.map.Location;

                    //console.log('dataviz');
                    //console.dir(kendo.dataviz);

                    // Indicator size in px
                    var SIZE = 100;

                    var extent = map.extent();
                    var center = map.center();

                    // Calculate distance across the middle of the map
                    // North and South distances can differ significantly at lower zoom levels
                    var eastCenter = new Location(center.lat, extent.nw.lng);
                    var westCenter = new Location(center.lat, extent.se.lng);
                    var distance = eastCenter.distanceTo(westCenter);

                    // Calculate scale in meters / pixel
                    var width = map.element.width();
                    var scale = Math.round(distance / width);

                    // Add a top-level div for the scale indicator
                    var wrap = $(".im-kendo-indicator-wrap", map.element);
                    if (wrap.length === 0) {
                        wrap = $("<div class='im-kendo-indicator-wrap' />").appendTo($('#' + $scope.model.mId));
                    }

                    // Render template
                    var template = kendo.template(
                        '<div class="im-kendo-indicator-text">#= size * scale # m</div>' +
                        '<div class="im-kendo-indicator" style="width: #= size #px;"></div>'
                    );
                    var data = {
                        size: SIZE,
                        scale: scale
                    };

                    wrap.html(template(data));
                }

                //var baseLayers = {
                //    "Topografisk norgeskart": topo4,
                //    //"Streets": streets,
                //    "Papirkart": toporaster3,
                //    "OpenStreetMap": openstreetmap,
                //    "Norges Grunnkart": norges_grunnkart,
                //    "Sj&oslash;kartraster": sjokartraster,
                //    "Europa": europa,
                //    "Satelittfoto": satelittFoto
                //};

                //var overlays = {
                //    "Fjellskygge": fjellskygge,
                //    "HRS-posisjon": hrspos,
                //    "Funnsted": funnsted,
                //    "Sirkler": sirkler,
                //    "Fylker": fylkesgrenser,
                //    "Kommuner": kommunegrenser,
                //    "Eiendomsgrenser": eiendomsgrenser
                //};

                $scope.mapOptions = {
                    center: [62.380073, 6.569921], //if $scope.center is undefined, center is initialized at our office
                    zoom: 12,
                    controls: {
                        attribution: false,
                        navigator: false
                    },
                    layers: [
                        // 0) topo
                        {
                            layerId: 0,
                            layerName: "Topo",
                            isOverlay: false,
                            isShown: false,
                            isDisabled: false,
                            type: "tile",
                            urlTemplate: "https://cache.kartverket.no/v1/wmts/1.0.0/topo/default/webmercator/#= z #/#= y #/#= x #.png",
                            subdomains: [],
                            attribution: $scope.layerAttribution('<a href="https://kartverket.no/">&copy; Kartverket</a>'),
                            minZoom: 0,
                            maxZoom: 18
                        },

                        // 1) topograatone
                        {
                            layerId: 1,
                            layerName: "Topograatone",
                            isOverlay: false,
                            isShown: false,
                            isDisabled: false,
                            type: "tile",
                            urlTemplate: "https://cache.kartverket.no/v1/wmts/1.0.0/topograatone/default/webmercator/#= z #/#= y #/#= x #.png",
                            subdomains: [],
                            attribution: $scope.layerAttribution('<a href="https://kartverket.no/">&copy; Kartverket</a>'),
                            minZoom: 0,
                            maxZoom: 18
                        },

                        // 2) toporaster
                        {
                            layerId: 2,
                            layerName: "Toporaster",
                            isOverlay: false,
                            isShown: false,
                            isDisabled: false,
                            type: "tile",
                            urlTemplate: "https://cache.kartverket.no/v1/wmts/1.0.0/toporaster/default/webmercator/#= z #/#= y #/#= x #.png",
                            subdomains: [],
                            attribution: $scope.layerAttribution('<a href="https://kartverket.no/">&copy; Kartverket</a>'),
                            minZoom: 0,
                            maxZoom: 18
                        },

                        // 3) sjokartraster
                        {
                            layerId: 3,
                            layerName: "Sjokartraster",
                            isOverlay: false,
                            isShown: false,
                            isDisabled: false,
                            type: "tile",
                            urlTemplate: "https://cache.kartverket.no/v1/wmts/1.0.0/sjokartraster/default/webmercator/#= z #/#= y #/#= x #.png",
                            subdomains: [],
                            attribution: $scope.layerAttribution('<a href="https://kartverket.no/">&copy; Kartverket</a>'),
                            minZoom: 0,
                            maxZoom: 18
                        },

                        // 4) Satelitt
                        {
                            layerId: 4,
                            layerName: 'satelittFoto',
                            isOverlay: false,
                            isShown: false,
                            isDisabled: false,
                            type: "tile",
                            urlTemplate: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/#= zoom #/#= y #/#= x #/",
                            //subdomains: ['opencache', 'opencache2', 'opencache3'],
                            //attribution: 'Esri, DigitalGlobe, Earthstar Geographics, CNES/Airbus DS, GeoEye, USDA FSA, USGS, Aerogrid, IGN, IGP, and the GIS User Community',
                            attribution: $scope.layerAttribution('Esri, DigitalGlobe, Earthstar Geographics, CNES/Airbus DS, GeoEye, USDA FSA, USGS, Aerogrid, IGN, IGP, and the GIS User Community'),
                            minZoom: 1,
                            maxZoom: 20
                        },

                        //5) OpenStreet
                        {
                            layerId: 5,
                            layerName: 'OpenStreet',
                            isOverlay: false,
                            isShown: false,
                            isDisabled: false,
                            type: "tile",
                            urlTemplate: "https://#= subdomain #.tile.openstreetmap.org/#= zoom #/#= x #/#= y #.png",
                            subdomains: ["a", "b", "c"],
                            //attribution: "&copy; <a href='https://osm.org/copyright'>OpenStreetMap contributors</a>",
                            attribution: $scope.layerAttribution('&copy; <a href="https://osm.org/copyright">OpenStreetMap contributors</a>'),
                            minZoom: 1,
                            maxZoom: 13
                        },

                        //6) BingMap: Needs to create an account and get an API Key. Then replace the key below and should be ready
                        /*{
                            layerId: 6,
                            layerName: 'BingMap',
                            isOverlay: false,
                            isShown: false,
                            isDisabled: false,
                            type: "bing",
                            imagerySet: "aerialWithLabels",

                            // IMPORTANT: This key is locked to demos.telerik.com
                            // Please replace with your own Bing Key
                            key: "PT90GNrnG5Bqxg1PfopA~Beliai2bFxJQJPNp-d2orA~AprjUTzhdIWJ5RikqfABIFIMXmOsjE6p4KClZs6lbakU5WtN-ENqHtEHLVSwqMpa",
                            //attribution: "",
                            attribution: $scope.layerAttribution(''),
                            minZoom: 1,
                            maxZoom: 20
                        },*/
                        /* Strava maps are not available anymore without log in and explicit permission from Strava.
                        {
                            layerId: 7,
                            layerName: 'Strava Heatmap All',
                            isOverlay: true,
                            isShown: false,
                            isDisabled: false,
                            type: "tile",
                            //urlTemplate: "https://anygis.ru/api/v1/Tracks_Strava_All_HD/#= zoom #/#= x #/#= y #",
                            urlTemplate: "https://heatmap-external-#= subdomain #.strava.com/tiles-auth/all/hot/#= zoom #/#= x #/#= y #.png",
                            subdomains: ["a", "b", "c"],
                            //subdomains: [],
                            //subdomains: ['opencache', 'opencache2', 'opencache3'],
                            //attribution: '<a href="http://www.kartverket.no/">&copy; Kartverket</a>',
                            attribution: $scope.layerAttribution('&copy; <a href="http://labs.strava.com/heatmap/">Strava</a>'),
                            minZoom: 1,
                            maxZoom: 15
                        },

                        {
                            layerId: 8,
                            layerName: 'Strava Heatmap Winter',
                            isOverlay: true,
                            isShown: false,
                            isDisabled: false,
                            type: "tile",
                            //urlTemplate: "https://#= subdomain #.tile.openstreetmap.org/#= zoom #/#= x #/#= y #.png",
                            //https://anygis.ru/api/v1/Tracks_Strava_Winter_HD/{x}/{y}/{z}
                            //https://heatmap-external-{s}.strava.com/tiles-auth/winter/hot/{z}/{x}/{y}.png?px=256
                            //urlTemplate: "https://anygis.ru/api/v1/Tracks_Strava_Winter_HD/#= z #/#= x #/#= y #",
                            urlTemplate: "https://heatmap-external-#= subdomain #.strava.com/tiles-auth/winter/hot/#= zoom #/#= x #/#= y #.png",
                            //urlTemplate: "https://#= subdomain #.statkart.no/gatekeeper/gk/gk.open_gmaps?layers=fjellskygge&zoom=#= z #&x=#= x #&y=#= y #",
                            subdomains: ["a", "b", "c"],
                            //subdomains: [],
                            //subdomains: ['opencache', 'opencache2', 'opencache3'],
                            //attribution: '<a href="http://www.kartverket.no/">&copy; Kartverket</a>',
                            attribution: $scope.layerAttribution('&copy; <a href="http://labs.strava.com/heatmap/">Strava</a>'),
                            minZoom: 1,
                            maxZoom: 15
                        },

                        {
                            layerId: 9,
                            layerName: 'Strava Heatmap Run',
                            isOverlay: true,
                            isShown: false,
                            isDisabled: false,
                            type: "tile",
                            urlTemplate: "https://heatmap-external-#= subdomain #.strava.com/tiles-auth/run/hot/#= zoom #/#= x #/#= y #.png",
                            subdomains: ["a", "b", "c"],
                            attribution: $scope.layerAttribution('&copy; <a href="http://labs.strava.com/heatmap/">Strava</a>'),
                            minZoom: 1,
                            maxZoom: 15
                            */
                    //}, {
                    //    layerId: 9,
                    //    layerName: 'Strava Heatmap Bike',
                    //    isOverlay: true,
                    //    isShown: false,
                    //    isDisabled: false,
                    //    type: "tile",
                    //    //urlTemplate: "https://#= subdomain #.tile.openstreetmap.org/#= zoom #/#= x #/#= y #.png",
                    //    //https://heatmap-external-{s}.strava.com/tiles/ride/bluered/{z}/{x}/{y}.png //.png?Key-Pair-Id=MYVALUE&Signature=MYVALUE&Policy=MYVALUE
                    //    //urlTemplate: "https://#= subdomain #.tile.openstreetmap.org/#= zoom #/#= x #/#= y #.png",
                    //    urlTemplate: "https://heatmap-external-#= subdomain #.strava.com/tiles/ride/bluered/#= zoom #/#= x #/#= y #.png",
                    //    //urlTemplate: "https://heatmap-external-#= subdomain #.strava.com/tiles-auth/all/hot/#= zoom #/#= x #/#= y #.png",
                    //    subdomains: ["a", "b", "c"],
                    //    //subdomains: [],
                    //    //subdomains: ['opencache', 'opencache2', 'opencache3'],
                    //    //attribution: '<a href="http://www.kartverket.no/">&copy; Kartverket</a>',
                    //    attribution: $scope.layerAttribution('&copy; <a href="http://labs.strava.com/heatmap/">Strava</a>'),
                    //    minZoom: 11,
                    //    maxZoom: 17
                    //}, {
                    //    layerId: 10,
                    //    layerName: 'Strava Heatmap Run',
                    //    isOverlay: true,
                    //    isShown: false,
                    //    isDisabled: false,
                    //    type: "tile",
                    //    //urlTemplate: "https://#= subdomain #.tile.openstreetmap.org/#= zoom #/#= x #/#= y #.png",
                    //    //https://heatmap-external-{s}.strava.com/tiles/run/bluered/{z}/{x}/{y}.png
                    //    urlTemplate: "https://heatmap-external-#= subdomain #.strava.com/tiles/run/bluered/#= z #/#= x #/#= y #.png",
                    //    //urlTemplate: "https://#= subdomain #.statkart.no/gatekeeper/gk/gk.open_gmaps?layers=fjellskygge&zoom=#= z #&x=#= x #&y=#= y #",
                    //    subdomains: ["a", "b", "c"],
                    //    //subdomains: [],
                    //    //subdomains: ['opencache', 'opencache2', 'opencache3'],
                    //    //attribution: '<a href="http://www.kartverket.no/">&copy; Kartverket</a>',
                    //    attribution: $scope.layerAttribution('&copy; <a href="http://labs.strava.com/heatmap/">Strava</a>'),
                    //    minZoom: 11,
                    //    maxZoom: 17
                    //}, {
                    //    layerId: 10,
                    //    layerName: 'Aim',
                    //    isOverlay: true,
                    //    isShown: false,
                    //    isDisabled: false,
                    //    type: "bubble",
                    //    attribution: $scope.layerAttribution(''),
                    //    style: {
                    //        fill: {
                    //            color: "#00f",
                    //            opacity: 0.4
                    //        },
                    //        stroke: {
                    //            width: 0
                    //        }
                    //    },
                    //    dataSource: {
                    //        transport: {
                    //            read: {
                    //                url: "../content/dataviz/map/urban-areas.json",
                    //                dataType: "json"
                    //            }
                    //        }
                    //    },
                    //    locationField: "Location",
                        //    valueField: "Pop2010"
                    //}
                    ],
                    markers: [],
                    //markers: [{
                    //    location: [30.268107, -97.744821],
                    //    shape: "pinTarget",
                    //    tooltip: {
                    //        content: "Austin, TX"
                    //    }
                    //}, {
                    //    id: "23",
                    //    name: "Funnsted,
                    //    "item_glyphicon": "fa-helicopter",
                    //    "item_glyphicon_color": "red",
                    //    "item_state": "gisposition",
                    //    "item_parms": "23",
                    //    "item_path": "23",
                    //    "position_accuracy": "4.2",
                    //    "dt": "2019-23-31 08:01:02",
                    //    "altitude": "123",
                    //    "altitude_accuracy": "4.9"
                    //    location: [62, 5.5],
                    //    shape: "pinTarget",
                    //    tooltip: {
                    //        content: "Norge en plass"
                    //    }
                    //}],
                    //markers: [{
                    //    "id": "23",
                    //    "name": "Funnsted",
                    //    "item_glyphicon": "fa-helicopter",
                    //    "item_glyphicon_color": "red",
                    //    "item_state": "gisposition",
                    //    "item_parms": "23",
                    //    "item_path": "23",
                    //    "lat": "6.2344",
                    //    "lng": "62.34543",
                    //    "position_accuracy": "4.2",
                    //    "dt": "2019-23-31 08:01:02",
                    //    "altitude": "123",
                    //    "altitude_accuracy": "4.9"
                    //}],
                    click: $scope.onClick,
                    beforeReset: $scope.onBeforeReset,
                    reset: $scope.onReset,
                    markerActivate: function (e) {
                        $(e.marker.element.context).css("color", e.marker.options.colorField);
                    },
                    //markerCreated: $scope.onMarkerCreated,
                    markerClick: $scope.onMarkerClick,
                    //resizeStart: $scope.onResizeStart,
                    resize: $scope.onResize,
                    //resizeEnd: $scope.onResizeEnd,
                    pan: $scope.onPan,
                    panEnd: $scope.onPanEnd,
                    //shapeClick: $scope.onShapeClick,
                    //shapeCreated: $scope.onShapeCreated,
                    //shapeFeatureCreated: $scope.onShapeFeatureCreated,
                    //shapeMouseEnter: $scope.onShapeMouseEnter,
                    //shapeMouseLeave: $scope.onShapeMouseLeave,
                    zoomStart: $scope.onZoomStart,
                    zoomEnd: $scope.onZoomEnd,
                    hide: function (layer) {
                        //if (angular.isUndefined(layer)) layer = $scope.model.currentLayer;
                        //layer = layer || $scope.model.currentLayer;
                        layer = layer !== undefined ? layer : $scope.model.currentLayer;
                        $scope.model.map.layers[layer].hide();
                        //$scope.model.map.layers[layer].isShown = true;
                        $scope.mapOptions.layers[layer].isShown = false;
                    },
                    hideAll: function () {
                        //console.log('map hide');
                        for (var l = 0; l < $scope.mapOptions.layers.length; l++) {
                            //$('#' + $scope.model.mId).data('kendoMap').layers[l].hide();
                            //$scope.model.map.layers[l].hide();
                            $scope.mapOptions.hide(l);
                        }
                    },
                    hideBase: function (layer) {
                        //if (angular.isUndefined(layer)) layer = $scope.model.currentLayer;
                        //layer = layer || $scope.model.currentLayer;
                        layer = layer !== undefined ? layer : $scope.model.currentLayer;
                        if ($scope.mapOptions.layers[layer].isOverlay === false) {
                            $scope.model.map.layers[layer].hide();
                            $scope.mapOptions.layers[layer].isShown = false;
                        }
                    },
                    hideBaseAll: function () {
                        for (var l = 0; l < $scope.mapOptions.layers.length; l++) {
                            if ($scope.mapOptions.layers[l].isOverlay === false) {
                                $scope.mapOptions.hideBase(l);
                            }
                        }
                    },
                    hideOverlay: function (layer) {
                        //if (angular.isUndefined(layer)) layer = $scope.model.currentLayer;
                        //layer = layer || $scope.model.currentLayer;
                        layer = layer !== undefined ? layer : $scope.model.currentLayer;
                        if ($scope.mapOptions.layers[layer].isOverlay === true) {
                            $scope.model.map.layers[layer].hide();
                            $scope.mapOptions.layers[layer].isShown = false;
                        }
                    },
                    hideOverlayAll: function () {
                        for (var l = 0; l < $scope.mapOptions.layers.length; l++) {
                            if ($scope.mapOptions.layers[l].isOverlay === true) {
                                $scope.mapOptions.hideOverlay(l);
                            }
                        }
                    },
                    show: function (layer) {
                        //console.log('map show');
                        //$scope.mapOptions.hideAll();

                        layer = layer !== undefined ? layer : $scope.model.currentLayer;
                        $scope.model.map.layers[layer].show();
                        //$scope.model.map.layers[layer].isShown = false;
                        $scope.mapOptions.layers[layer].isShown = true;
                        //console.log('Current Layer: ' + $scope.mapOptions.layers[layer].layerName);
                        $scope.reCenter();

                        //$scope.model.map = $('#' + $scope.model.mId).data('kendoMap');
                        //console.dir($scope.model.map);
                    },
                    showOverlay: function (layer) {
                        layer = layer !== undefined ? layer : $scope.model.currentLayer;
                        if ($scope.mapOptions.layers[layer].isOverlay === true) {
                            $scope.model.map.layers[layer].show();
                            $scope.mapOptions.layers[layer].isShown = true;
                            $scope.reCenter();
                        }
                    },
                    toggle: function (layer) {
                        if ($scope.mapOptions.layers[layer].isShown === true) {
                            $scope.mapOptions.show(layer);
                        } else {
                            $scope.mapOptions.hide(layer);
                        }
                    },
                    baseLayerList: function () {
                        var baseLayerList = [];
                        for (var l = 0; l < $scope.mapOptions.layers.length; l++) {
                            if ($scope.mapOptions.layers[l].isOverlay === false) {
                                baseLayerList.push($scope.mapOptions.layers[l]);
                            }
                        }
                        return baseLayerList;
                    },
                    overlayList: function () {
                        var overlayList = [];
                        for (var l = 0; l < $scope.mapOptions.layers.length; l++) {
                            if ($scope.mapOptions.layers[l].isOverlay === true) {
                                overlayList.push($scope.mapOptions.layers[l]);
                            }
                        }
                        return overlayList;
                    }
                };

                $scope.$watch(function () {
                    return $scope.center;
                }, function (newValue, oldValue) {
                    if (angular.isUndefined($scope.center) || $scope.center.length === 0 || angular.isUndefined($scope.model.map) || angular.isUndefined(newValue) || $scope.model.isInitialized === false) return;
                    //console.log('center updated ' + $scope.center);

                    //$scope.mapOptions.center = $scope.center;
                    $scope.model.map.center($scope.center);
                    //$scope.model.map.markers.clear();
                    //$scope.model.map.markers.add({
                    //    shape: "pinTarget",
                    //    location: $scope.center,
                    //    colorField: "red"
                    //});
                    //angular.forEach($scope.model.imMapMarkers, function (data) {
                    //    console.dir(data);
                    //    $scope.model.map.markers.add({
                    //        shape: data.shape,
                    //        location: [data.lat, data.lng],
                    //        colorField: data.colorField
                    //    });
                    //});
                    ////$scope.model.map.markers.add({
                    ////    shape: "pin",
                    ////    location: [$scope.center[0] + 0.002, $scope.center[1] + 0.002],
                    ////    colorField: "green"
                    ////});
                }, true);

                $scope.$watch(function () {
                    return $scope.markers;
                }, function (newValue, oldValue) {
                    if (angular.isUndefined($scope.markers) || $scope.markers.length === 0 || angular.isUndefined($scope.model.map) || angular.isUndefined(newValue) || $scope.model.isInitialized === false) return;

                    //console.log('markers updated ' + $scope.markers);
                    //console.dir($scope.markers);

                    var containsMe = false;

                    angular.forEach($scope.markers, function (item) {
                        containsMe = false;
                        for (var i = 0; i < $scope.model.imMapMarkers.length; i++) {
                            if ($scope.model.imMapMarkers[i].id === item.id) {
                                containsMe = true;
                                break;
                            }
                        }

                        if (!containsMe) {
                            var shp = 'pinTarget';
                            var id = item.id;
                            var clr = item.item_glyphicon_color;
                            var lat = item.locations[0].lat;
                            var lng = item.locations[0].lng;
                            var type = item.type;
                            var parms = item.item_parms;
                            $scope.model.map.markers.add({
                                id: id,
                                shape: shp,
                                location: [lat, lng],
                                colorField: clr
                            });

                            $scope.model.imMapMarkers.push({ id: id, lat: lat, lng: lng, shape: shp, type: type, colorField: clr, parms: parms });
                        }
                    });

                    if (angular.isUndefined($scope.center)) {
                        $scope.mapOptions.center = [$scope.markers[0].locations[0].lat, $scope.markers[0].locations[0].lng];
                        $scope.model.map.center([$scope.markers[0].locations[0].lat, $scope.markers[0].locations[0].lng]);
                    }
                }, true);

                $scope.$watch(function () {
                    return document.fullscreen;
                }, function (newValue) {
                    //if (angular.isUndefined($scope.setup.encodingtype) || $scope.setup.encodingtype === '' || angular.isUndefined(newValue)) return;

                    if (document.fullscreen === true) {
                        fullIsOn = true;
                    } else {
                        fullIsOn = false;
                    }
                });

                $scope.$watch(function () {
                    return $scope.height;
                }, function (newValue) {
                    if (angular.isUndefined($scope.height) || $scope.height === '' || angular.isUndefined(newValue)) return;

                    if ($scope.height === 'dynamic' || $scope.height === 'dynamic-o' || $scope.height === 'dynamic-h') {
                        var headerHeight = 70;

                        if ($scope.height === 'dynamic-h') headerHeight += 47;

                        if ($scope.height === 'dynamic-o' && angular.isDefined($scope.heightOffset) && $scope.heightOffset !== '') headerHeight = $scope.heightOffset;

                        var h = $(window).innerHeight() - headerHeight;

                        if (h < $scope.model.mapHeightMinimum) h = $scope.model.mapHeightMinimum;

                        $scope.model.mapHeightBase = h;

                        if (fullIsOn) {
                            $scope.model.mapHeightCurrent = h;
                        } else {
                            $scope.model.mapHeightCurrent = $scope.model.mapHeightBase;
                        }
                    } else {
                        $scope.model.mapHeightBase = newValue;
                        $scope.model.mapHeightCurrent = $scope.model.mapHeightBase;
                    }
                });
            }
        };

        return directive;
    }]);
})();
